import { useSelector } from "react-redux"
import UserRoles from "constants/UserRoles"

export function useUserRole() {
   const user = useSelector(state => state?.userAuth?.user)
   const role = user?.type

   const isPlantManager = role === UserRoles.PlantManager
   const isAssistantPlantManager = role === UserRoles.AssistantPlantManager
   //    const isAdmin = role === UserRoles.Admin || role === UserRoles.SuperAdmin

   return {
      role,
      isPlantManager,
      isAssistantPlantManager,
   }
}
